itsoftApp.createModule("antispam-email", function () {
  const regExp = /<span>blank<\/span>/gi;

  document.addEventListener("click", setEmailHandler);

  function setEmailHandler(event) {
    if (event.target instanceof HTMLElement) {
      if (event.target.classList.contains("js-antispam-email")) {
        const email = event.target.innerHTML.replace(regExp, "").trim();
        mailto(email);
      }
    }
  }

  function mailto(email) {
    window.location.href = `mailto:${email}`;
  }
});
